export default {
  GET_CHATS: "GET_CHATS",
  LOAD_MESSAGES: "LOAD_MESSAGES",
  SEND_MESSAGE: "SEND_MESSAGE",
  MARK_ALL_MESSAGES_AS_READ: "MARK_ALL_MESSAGES_AS_READ",
  GET_UNREAD_MESSAGE_COUNT: "GET_UNREAD_MESSAGE_COUNT",
};
